export default __webpack_public_path__ + "static/media/UV.96a0166a.webp";